import { getCookieValue } from '@naturehouse/nh-essentials/lib/cookies/cookie';

const PREFIX = '_nhft_';

export enum DeploymentEnvironment {
    DEV = 'dev',
    PROD = 'prod'
}

export enum FeatureToggle {
    TRANSLATIONS = 'translations',
    OPEN_GDS_ONBOARDING = 'open-gds-onboarding',
    GENERAL_SCORE_FIVE_SCALE = 'general-score-five-scale',
    VOUCHERS = 'vouchers'
}

export function isFeatureEnabled(name: string): boolean {
    const cookieValue = getCookieValue(PREFIX + name);
    return cookieValue === 'true';
}
